<app-loader></app-loader>
<alert></alert>

<router-outlet>
</router-outlet>